/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function DotsSix(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M72,92.0001a12,12,0,1,1-12-12A12,12,0,0,1,72,92.0001Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,128,80.0001Zm68,24a12,12,0,1,0-12-12A12,12,0,0,0,196,104.0001Zm-136,48a12,12,0,1,0,12,12A12,12,0,0,0,60,152.0001Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,152.0001Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,196,152.0001Z" />
    </Svg>
  );
}

export default DotsSix;
